import { Checkbox, FormControlLabel, TextField } from "@mui/material";
import React from "react";
interface Props {
  eventName: string;
  fieldName: string;
  fieldSchema: any;
  formData: Record<string, any>;
  handleChange: (eventName: string, field: string, value: any) => void;
}
export const EventFieldComponent: React.FC<Props> = React.memo(
  ({ eventName, fieldName, fieldSchema, formData, handleChange }) => {
    const value = formData[eventName]?.[fieldName] || "";
    const type = fieldSchema.type;
    const typeFormat = fieldSchema.format;
    return (
      <>
        {type === "string" && (
          <TextField
            key={fieldName}
            fullWidth
            variant="outlined"
            label={`${fieldName}${typeFormat ? ` - ${typeFormat}` : ` - ${type}`}`}
            value={value}
            size="small"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChange(eventName, fieldName, e.target.value)
            }
            margin="dense"
          />
        )}
        {type === "boolean" && (
          <FormControlLabel
            key={fieldName}
            control={
              <Checkbox
                checked={!!value}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChange(eventName, fieldName, e.target.checked)
                }
              />
            }
            label={fieldName}
          />
        )}
        {(type === "integer" || type === "number") && (
          <TextField
            key={fieldName}
            fullWidth
            type="number"
            variant="outlined"
            label={`${fieldName}${typeFormat ? ` - ${typeFormat}` : ` - ${type}`}`}
            value={value}
            size="small"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const num = e.target.value === "" ? undefined : Number(e.target.value);
              handleChange(eventName, fieldName, num);
            }}
            margin="dense"
          />
        )}
      </>
    );
  }
);
